import * as Sentry from '@sentry/browser'
import { computed, makeObservable } from 'mobx'

import type { Model } from 'modules/core/lib/mobx-rest'

abstract class Policy<V> {
  target: Model

  constructor(target: Model) {
    makeObservable(this, {
      permissions: computed,
      metadata: computed,
    })
    this.target = target
  }

  /**
   * @deprecated Don't get policies from MobX collections. Check them through GraphQL in your page components.
   */
  can(verb: V): boolean {
    try {
      return this.checkVerb(verb)
    } catch (e) {
      if (e instanceof TypeError) {
        const message = `'${verb}' verb was not found in the permissions collection.`
        Sentry.captureException(message)
        console.error(message)
      } else {
        Sentry.captureException(e)
        console.error(e)
      }
      return false
    }
  }

  protected abstract checkVerb(verb: V): boolean

  get permissions(): Record<string, any> {
    return this.target.attributes.permissions
  }

  get metadata(): Record<string, any> {
    return this.target.attributes.metadata
  }
}

export default Policy
